// Css =>
import '../../BaseStructure.css'
import Styled from './SpinnerBar.module.css';

function SpinnerBar() {
    return(
        <>
            <div className="row" id={ Styled.SpinnerFrame }>
                <span className={ Styled.loader }></span>
            </div>

            <div className="row">
                <div className="col-12">
                    <h3>لطفا منتظر بمانید!</h3>
                </div>
            </div>
        </>
    )
}

export default SpinnerBar;
